import { useEffect, useState } from "react";
import { api } from "../../../software/api";

// Missed calls nobody has viewed yet — drives the red badge on the top bar Calls button.
export function useMissedCalls() {
  const [n, setN] = useState(0);
  useEffect(() => {
    const f = () => { if (document.visibilityState === "visible") api("GET", "/calls/missed-count").then((d) => setN(d.count || 0)).catch(() => {}); };
    f(); const t = setInterval(f, 10000);
    window.addEventListener("aqualux:calls-changed", f);
    return () => { clearInterval(t); window.removeEventListener("aqualux:calls-changed", f); };
  }, []);
  return n;
}
